import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IGroupImage } from 'app/library/group/interfaces/group-avatar.interface';
import { GroupCommand } from 'app/library/group/models/group.command.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { FileCommand } from 'app/projects/core/src/lib/models/file.command';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { NotifyType } from 'app/projects/shared/src/lib/enums/notify-type.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GroupAvatar } from '../../group/models/group-avatar';
import { IModuleGroupQuery } from '../interfaces/module-group.query.interface';
import { ModuleGroup } from '../models/module-group';
import { ModuleGroupCommand } from '../models/module-group.command.model';

@Injectable()
export class ModuleGroupApiService extends EntityService<IModuleGroupQuery, ModuleGroupCommand> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'modules/groups');
    }

    getAll(moduleId: string): Observable<ModuleGroup[]> {
        return this.http.get<IModuleGroupQuery[]>(`${this.apiUrl}/modules/${moduleId}/groups`).pipe(map((queries) => queries.map((query) => new ModuleGroup(query))));
    }

    create(entity: ModuleGroup): Observable<ModuleGroup> {
        const data = new ModuleGroupCommand(entity);

        return this.http.post<IModuleGroupQuery>(`${this.apiUrl}/${this.entities}`, data).pipe(map((query) => new ModuleGroup(query)));
    }

    read(id: string): Observable<ModuleGroup> {
        return this.http.get<IModuleGroupQuery>(`${this.apiUrl}/${this.entities}/${id}`).pipe(map((query) => new ModuleGroup(query)));
    }

    update(entity: ModuleGroup): Observable<ModuleGroup> {
        const data = new GroupCommand(entity);

        return this.http.patch<IModuleGroupQuery>(`${this.apiUrl}/${this.entities}/${entity.id}`, data).pipe(map((query) => new ModuleGroup(query)));
    }

    delete(id: string, notify: NotifyType): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${this.entities}/${id}?notify=${notify}`);
    }

    leaveGroup(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/groups/${id}/leave-group`);
    }

    uploadImage(file: File, id: string): Observable<GroupAvatar> {
        const data = new FileCommand('file', new File([file], '', { type: file.type }), file.name).formData;

        return this.http.post<IGroupImage>(`${this.apiUrl}/groups/${id}/image`, data).pipe(map((query) => new GroupAvatar(query)));
    }
}
